import React from 'react';
export function SocialTicker() {
  const items = ['🟢 Carlos de Madrid acaba de unirse', '🟢 Andrea de México DF activó su protocolo', '🟢 Miguel de Buenos Aires completó el Día 14', '🟢 Laura de Bogotá descargó la app', '🟢 Roberto de Santiago alcanzó racha de 7 días', '🟢 Elena de Miami desbloqueó el nivel 2'];
  // Duplicate for seamless marquee
  const tickerItems = [...items, ...items, ...items];
  return <div className="w-full bg-brand-card border-y border-brand-border overflow-hidden py-2.5" data-id="element-670">
      <div className="flex whitespace-nowrap animate-marquee w-[200%]" data-id="element-671">
        {tickerItems.map((item, idx) => <span key={idx} className="text-sm text-brand-muted font-medium mx-6" data-id="element-672">
            {item}
          </span>)}
      </div>
    </div>;
}